import { API } from '../../api/API';
import { BUSINESS_ACCOUNTS_URL, USER_ACCOUNT_URL,BUSINESS_ACCOUNT_TYPES_URL,
    USER_EMAIL_ADDRESS_EXISTS } from '../../config/config';

export const getAccountTypes = async () => {
    let response = await API.get(BUSINESS_ACCOUNT_TYPES_URL);
    return response.data;
}

export const getAccounts = async (page, size, keyword="") => {
    let response = await API.get(BUSINESS_ACCOUNTS_URL,{
        params: {
          size: size,
          page: page,
          keyword: keyword.trim(),
        }
    });
    return response.data;    
}

export const registerAccount = async (formdata) => {
    let response = await API.post(BUSINESS_ACCOUNTS_URL, formdata)
    if (response.status === 201) {
        response.data = {
            ...response.data,
            'success': true,
            'message': 'Account was created successfully'
        };
    }
    return response.data;
}

export const getAccountType = (id, accountTypes) => {
    let type = '';
    let displayName = ''
    accountTypes.filter((accountTypeObj) => {
        if (accountTypeObj.id === id) {
            type = accountTypeObj.accountType;
            displayName = accountTypeObj.accountTypeDisplayName;
        }
    })
    return {type, displayName};
}

export const getUsersByAccount = async (accountId) => {
    let response = await API.get(USER_ACCOUNT_URL + '/' + accountId);
    return response.data;
}

export const deleteAccount = async (accountId) => {
    let response = await API.delete(BUSINESS_ACCOUNTS_URL + '/' + accountId);
    return response.data;
}

export const getUserByEmailAddress = async (emailAddress) => {
    try{
        let emailExistsUrl = USER_EMAIL_ADDRESS_EXISTS.replace('${userEmailAddress}',emailAddress);
        let response = await API.get(emailExistsUrl);
        return response.data;
    } catch (err) {
        return null;
    }
}

export const getAccountById = async (accountId) => {
    let response = API.get(BUSINESS_ACCOUNTS_URL + '/' + accountId);
    return (await response).data;
}

export const updateAccount = async (accountId, accountData) => {
    let response = await API.put(BUSINESS_ACCOUNTS_URL + '/' + accountId, accountData)
    return response.data;
}